import Selection from './selection';
import Box from './box';
import Zoom from './zoom';
import Pan from './pan';

export default {
    selection:Selection,
    box:Box,
    zoom:Zoom,
    pan:Pan
};
